import React, { useState } from "react";
import { downloadSampleCSV, parseCSV } from "../utils/csvUtils";
import { showToast } from "../components/ToastifyNotification";
import { useDispatch } from "react-redux";

const BulkImport = ({
  columns,
  onSubmit,
  sampleFileName = "sample.csv",
  payloadKey = "data"
}) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);

  const handleImport = async () => {
    if (!file) {
      showToast("error", "Please select a CSV file");
      return;
    }

    try {
      dispatch({ type: "LOADER_START" });

      const parsedData = await parseCSV(file, columns);

      if (!parsedData.length) {
        showToast("error", "No valid records found");
        return;
      }

      await onSubmit({
        [payloadKey]: parsedData
      });

      // setFile(null);
    } catch (err) {
      showToast("error", err);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  return (
    <div className="card mt-4">
      <div className="card-header">
        <h5>Bulk Import</h5>
      </div>

      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <input
              type="file"
              accept=".csv"
              className="form-control"
              onChange={e => setFile(e.target.files[0])}
            />
          </div>
          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-link mt-2"
              onClick={() => downloadSampleCSV(columns, sampleFileName)}
            >
              Download Sample CSV
            </button>
          </div>
        </div>
      </div>

      <div className="card-footer text-end">
        <button className="btn btn-primary" onClick={handleImport}>
          Import
        </button>
      </div>
    </div>
  );
};

export default BulkImport;
